<template>
  <blockquote class="text-foreground border-l-2 pl-6 italic  leading-6 font-normal text-base">
    <slot />
  </blockquote>
</template>